// extracted by mini-css-extract-plugin
module.exports = {"closeClickableArea":"_42b0f02","transluscentWhite":"_6f4352cc","closeIcon":"_4be4da3a","closeButtonDisabled":"_f1076337"};